import React from 'react';
import { Box, Card, CardContent, Stack, Typography, styled, Alert } from '@mui/material';
import { People as UsersIcon, Business as BuildingIcon } from '@mui/icons-material';
import { useFormContext, Controller } from 'react-hook-form';

const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'cardType' && prop !== 'selected',
})(({ theme, selected, cardType }) => ({
  cursor: 'pointer',
  border: `2px solid ${selected ? 
    (cardType === 'jobseeker' ? theme.palette.primary.main : theme.palette.success.main) : 
    theme.palette.grey[300]}`,
  backgroundColor: selected ? 
    (cardType === 'jobseeker' ? theme.palette.primary.light : theme.palette.success.light) : 
    theme.palette.background.paper,
  transition: 'all 0.2s',
  '&:hover': {
    borderColor: theme.palette.grey[400]
  }
}));

const UserTypeStep = () => {
  const { control, watch, formState: { errors } } = useFormContext();
  const userType = watch('userType');

  return (
    <Stack spacing={3} alignItems="center">
      <Stack spacing={1} alignItems="center">
        <Typography variant="h4" color="text.primary">Welcome! Let's get you started</Typography>
        <Typography color="text.secondary">First, tell us what brings you here</Typography>
      </Stack>

      <Box sx={{ maxWidth: 'md', width: '100%' }}>
        <Stack spacing={2}>
          <Controller
            name="userType"
            control={control}
            render={({ field }) => (
              <StyledCard 
                selected={userType === 'jobseeker'}
                cardType="jobseeker"
                onClick={() => field.onChange('jobseeker')}
                data-testid="user-type-jobseeker"
              >
                <CardContent sx={{ textAlign: 'center', py: 3 }}>
                  <UsersIcon sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h5" gutterBottom>Looking for Work</Typography>
                  <Typography variant="body2" color="text.secondary">I'm seeking job opportunities</Typography>
                </CardContent>
              </StyledCard>
            )}
          />

          <Controller
            name="userType"
            control={control}
            render={({ field }) => (
              <StyledCard 
                selected={userType === 'company'}
                cardType="company"
                onClick={() => field.onChange('company')}
                data-testid="user-type-company"
              >
                <CardContent sx={{ textAlign: 'center', py: 3 }}>
                  <BuildingIcon sx={{ fontSize: 40, color: 'success.main', mb: 2 }} />
                  <Typography variant="h5" gutterBottom>Hiring Workers</Typography>
                  <Typography variant="body2" color="text.secondary">I need to find qualified workers</Typography>
                </CardContent>
              </StyledCard>
            )}
          />
        </Stack>
        
        {errors.userType && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {errors.userType.message}
          </Alert>
        )}
      </Box>
    </Stack>
  );
};

export default UserTypeStep;